import { Location } from '@app/shared/routes';

const FacilityManagementLocation = new Location({
  path: '/facility-management'
});

export { FacilityManagementLocation };
